import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { ProfileRead } from 'src/app/profiles/shared/profile-read.model';
import { SelectItem } from 'primeng/api';
import { VerticalNahbService } from 'src/app/vertical/nahb/shared/vertical-nahb.service';
import { HbaProfileReadDto } from 'src/app/vertical/nahb/shared/dto/hba-profile.read.dto';
import { NgForm } from '@angular/forms';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-nahb-profile-type-edit',
  templateUrl: './nahb-profile-type-edit.component.html',
  styleUrls: ['./nahb-profile-type-edit.component.less'],
    standalone: false
})
export class NahbProfileTypeEditComponent implements OnInit, OnChanges {
  @Input() profileId: number;

  @ViewChild('profileTypeForm') _profileTypeForm: NgForm;

  hbaProfile: HbaProfileReadDto;
  membershipTypeItems: SelectItem[] = [];
  membershipStatusItems: SelectItem[] = [];
  numberOfUnitsItems: SelectItem[] = [];
  dollarVolumeItems: SelectItem[] = [];
  businessActivityItems: SelectItem[] = [];
  contactTitleItems: SelectItem[] = [];
  showCustomPrimaryBusinessActivity = false;
  otherCustomPrimaryBusinessActivityCodes = []

  constructor(private _verticalNahbService: VerticalNahbService, private _notificationService: NotificationService) { }

  ngOnInit(): void {
    this._verticalNahbService.getHbaMemberTypes().then((types) => {
      this.membershipTypeItems = types
        .map<SelectItem>((x) => {
          return { label: x.Descr, value: x.Code };
        })
        .sort(function (a, b) {
          const textA = a.label.toUpperCase();
          const textB = b.label.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    });

    this._verticalNahbService.getHbaMembershipStatuses().then((statuses) => {
      this.membershipStatusItems = statuses
        .map<SelectItem>((x) => {
          return { label: x.Descr, value: x.Code };
        })
        .sort(function (a, b) {
          const textA = a.label.toUpperCase();
          const textB = b.label.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    });

    this._verticalNahbService.getHbaNumberOfUnits().then((units) => {
      this.numberOfUnitsItems = units.map<SelectItem>((x) => {
        return { label: x.Descr, value: x.Code };
      });
    });

    this._verticalNahbService.getHbaDollarVolumes().then((volumes) => {
      this.dollarVolumeItems = volumes.map<SelectItem>((x) => {
        return { label: x.Descr, value: x.Code };
      });
    });

    this._verticalNahbService.getHbaBusinessActivityTypes().then((activityTypes) => {
      this.businessActivityItems = activityTypes
        .map<SelectItem>((x) => {
          return { label: x.Descr, value: x.Code };
        })
        .sort(function (a, b) {
          const textA = a.label.toUpperCase();
          const textB = b.label.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      activityTypes.forEach(at => {
        if (at.Descr.split(" ")[0].toLowerCase() === "other") {
          this.otherCustomPrimaryBusinessActivityCodes.push(at.Code);
        }
      })
      
      if (this.hbaProfile) {
        this.handlePrimaryBusinessActivity(this.hbaProfile.PrimaryBusActivityCode);
      }
      
    });

    this._verticalNahbService.getHbaContactTitleTypes().then((titles) => {
      this.contactTitleItems = titles
        .map<SelectItem>((x) => {
          return { label: x.Descr, value: x.Code };
        })
        .sort(function (a, b) {
          const textA = a.label.toUpperCase();
          const textB = b.label.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.profileId && this.profileId) {
      this._verticalNahbService.getProfileHbaData(this.profileId).then((hbaProfile) => {
        this.hbaProfile = hbaProfile;
        this.handlePrimaryBusinessActivity(hbaProfile.PrimaryBusActivityCode);
      });
    }
  }

  public save(): Promise<void> {
    if (this._profileTypeForm?.dirty) {
      return this._verticalNahbService
        .upsertProfileHbaData(this.hbaProfile)
        .then(() => {
          this._profileTypeForm?.form.markAsPristine();
        })
        .catch((err) => {
          this._notificationService.httpError(err);
        });
    }
  }

  handlePrimaryBusinessActivity(code: string) {
    this.showCustomPrimaryBusinessActivity = this.otherCustomPrimaryBusinessActivityCodes.includes(code);
  }
}
